<template>
  <loading-list v-if="viewData.loadingPage"></loading-list>
  <b-container class="mt-3" v-else-if="viewData.success">
    <b-alert show variant="success">
      <h4 class="alert-heading mt-3">Sucesso!</h4>
      <p v-if="this.isAdmin">
        <a href="/#/login">Clique aqui para entrar na aplicação.</a>
      </p>
      <p v-else>Nova senha cadastrada</p>
      <hr />
    </b-alert>
  </b-container>
  <b-form class="form-signin" v-else>
    <img class="mb-4" src="/images/logo_veins.png" alt style="width: 19em" />
    <h1 class="h3 mb-3 font-weight-normal">Crie sua senha</h1>

    <error-container v-bind:errors="viewData.errors || []" />

    <b-form-group v-if="!viewData.success">
      <label for="inputPassword" class="sr-only">Nova Senha</label>
      <b-input
        type="password"
        pattern="[0-9]*"
        inputmode="numeric"
        :max="6"
        :state="isOk('newPassword')"
        v-model="state.newPassword"
        :formatter="validatePasswordLength"
        placeholder="Defina uma senha"
        v-on:keyup.enter="save"
        required
      />
      <b-form-invalid-feedback style="text-align:left">{{
        getError('newPassword')
      }}</b-form-invalid-feedback>
    </b-form-group>

    <b-form-group>
      <label for="inputPassword" class="sr-only">Confirmar Nova Senha</label>
      <b-input
        :max="6"
        :state="isOk('newPasswordConfirm')"
        :formatter="validatePasswordLength"
        v-model="state.newPasswordConfirm"
        type="password"
        placeholder="Confirmar senha"
        v-on:keyup.enter="save"
        required
      />
      <b-form-invalid-feedback style="text-align:left">{{
        getError('newPasswordConfirm')
      }}</b-form-invalid-feedback>
    </b-form-group>
    <button
      type="button"
      v-bind:disabled="viewData.loading"
      class="btn btn-primary btn-lg btn-block"
      v-on:click="save"
    >
      <b-icon
        v-if="viewData.loading"
        icon="three-dots"
        animation="cylon"
      ></b-icon>
      <span v-else>Entrar</span>
    </button>
  </b-form>
</template>

<script>
import { Api } from '../vue/api';
import helpers from '../vue/helpers';

const API = new Api();

export default {
  name: 'change-password',
  data: function() {
    return {
      state: {
        newPassword: '',
        newPasswordConfirm: '',
      },
      viewData: {
        loading: false,
        errors: [],
        loadingPage: true,
        success: false,
      },
    };
  },
  computed: {
    isAdmin() {
      return this.$route.path.indexOf('admin') >= 0;
    },
    url() {
      return this.isAdmin ? '/run' : '/user/run';
    },
  },
  beforeMount: async function() {
    try {
      this.viewData.loadingPage = true;

      await API.post(this.url, {
        path: '/recover-password/' + this.$route.params.token,
        method: 'get',
      });
    } catch (ex) {
      this.$toast.error(helpers.getFirstError(ex));
    }

    this.viewData.loadingPage = false;
  },
  methods: {
    validatePass() {
      if (this.state.newPassword && this.state.newPassword.length >= 6) {
        this.state.newPassword = this.state.newPassword.substring(0, 6);
      }
    },
    validatePasswordLength(text) {
      return String(text).substring(0, 6);
    },
    getError(property) {
      return helpers.getError(this.viewData.errors, property);
    },
    isOk(property) {
      const hasError = helpers.hasError(this.viewData.errors, property);

      if (hasError) {
        return false;
      }

      return true;
    },
    async save() {
      try {
        this.viewData.loading = true;
        await API.post(this.url, {
          path: '/recover-password/' + this.$route.params.token,
          method: 'put',
          data: this.state,
        });

        this.viewData.success = true;
      } catch (ex) {
        this.viewData.errors = helpers.getErrors(ex);
      }

      this.viewData.loading = false;
    },
  },
  components: {},
};
</script>
